import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Layout, Menu, Icon } from "antd";
import { infoRolUser } from "../../api/auth";

import "./MenuSider.scss";

const { SubMenu } = Menu;

function MenuSider(props) {
  const { Sider } = Layout;
  const { menuCollpased, location } = props;
  const rol = infoRolUser();

  return (
    <Sider className="admin-sider" collapsed={menuCollpased}>
      {rol === 1 ? <MenuAdmin location={location} /> : ""}

      {rol === 2 ? <MenuUsuario location={location} /> : ""}
    </Sider>
  );
}

function MenuAdmin(props) {
  const { location } = props;
  return (
    <Menu theme="dark" mode="inline" defaultSelectedKeys={location.pathname}>
      <Menu.Item key="/inicio">
        <Link to={"/inicio"}>
          <Icon type="home" />
          <span className="nav-text">Inicio</span>
        </Link>
      </Menu.Item>
      <SubMenu
        key="subproveedores"
        title={
          <span>
            <Icon type="solution" />
            <span>Proveedores</span>
          </span>
        }
      >
        <Menu.Item key="/admin/proveedores">
          <Link to={"/admin/proveedores"}>
            <Icon type="eye" />
            <span className="nav-text">Consultar</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/admin/cargacertificados">
          <Link to={"/admin/cargacertificados"}>
            <Icon type="cloud-upload" />
            <span className="nav-text">Carga Certificados</span>
          </Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu
        key="subusuarios"
        title={
          <span>
            <Icon type="user" />
            <span>Usuarios</span>
          </span>
        }
      >
        <Menu.Item key="/admin/usuarios">
          <Link to={"/admin/usuarios"}>
            <Icon type="eye" />
            <span className="nav-text">Usuarios</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/admin/cargausuarios">
          <Link to={"/admin/cargausuarios"}>
            <Icon type="cloud-upload" />
            <span className="nav-text">Carga Masiva</span>
          </Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu
        key="subreportes"
        title={
          <span>
            <Icon type="printer" />
            <span>Reportes</span>
          </span>
        }
      >
        <Menu.Item key="/reportes/consultacertificados">
          <Link to={"/reportes/consultacertificados"}>
            <Icon type="file-search" />
            <span className="nav-text">Informe Consultas</span>
          </Link>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
}

function MenuUsuario(props) {
  const { location } = props;

  return (
    <Menu theme="dark" mode="inline" defaultSelectedKeys={location.pathname}>
      <Menu.Item key="/inicio">
        <Link to={"/inicio"}>
          <Icon type="home" />
          <span className="nav-text">Inicio</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/proveedor/certificados">
        <Link to={"/proveedor/certificados"}>
          <Icon type="safety-certificate" />
          <span className="nav-text">Consultas</span>
        </Link>
      </Menu.Item>
    </Menu>
  );
}

export default withRouter(MenuSider);
